import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const ExclamationCircle = ({ size, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM14 8C14 7.44772 14.4477 7 15 7H17C17.5523 7 18 7.44772 18 8V16C18 16.5523 17.5523 17 17 17H15C14.4477 17 14 16.5523 14 16V8ZM19 22C19 23.6569 17.6569 25 16 25C14.3431 25 13 23.6569 13 22C13 20.3431 14.3431 19 16 19C17.6569 19 19 20.3431 19 22Z"
        fill={color}
      />
    </svg>
  );
};

export default ExclamationCircle;
